module.exports = __webpack_public_path__ + "static/media/icon-save.0f2d936a.svg";